import './App.css';
import Home from './Components/Home';
import Navbar from './Components/Navbar';
import Product from './Components/Product';
import Products from './Components/Products';
import {Switch, Route, Link, Routes} from 'react-router-dom';

function App() {
  return (
    <>
    <Navbar/>
    <Routes>
    <Route exact path="/" Component={Home}/>
    <Route exact path="/products" Component={Products}/>
    <Route exact path="/products/:id" Component={Product}/>
    </Routes>
    </>
  );
}

export default App;
